import { Section } from '@/components/ui/index.js';
import { describeAudit, TONE_CLASSES } from '@/lib/auditDescriptors.js';
import type { UserDetailResponse } from '@/lib/types.js';

type AuditEntry = UserDetailResponse['audit_logs'][number];

interface Props {
  logs: readonly AuditEntry[];
  fmtDate: (s: string | null | undefined) => string;
  fmtDateTime: (s: string | null | undefined) => string;
}

export function AuditLogsList({ logs, fmtDate, fmtDateTime }: Props): JSX.Element {
  return (
    <Section title="最近 30 条审计日志">
      {logs.length === 0 ? (
        <p className="text-sm text-slate-500">暂无记录</p>
      ) : (
        <ol className="space-y-2 text-xs">
          {logs.map((a) => {
            const desc = describeAudit(a.action, a.payload, { fmtDate });
            return (
              <li key={a.id} className="border-l-2 border-white/10 pl-3 py-1">
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-sm shrink-0">{desc.emoji}</span>
                  <span className={`text-sm ${TONE_CLASSES[desc.tone]}`}>{desc.summary}</span>
                  <span className="text-slate-500">{fmtDateTime(a.created_at)}</span>
                  {a.ip !== null && <span className="text-slate-600">IP {a.ip}</span>}
                </div>
                <code className="block mt-0.5 text-[10px] text-slate-600 font-mono">
                  {a.action}
                </code>
              </li>
            );
          })}
        </ol>
      )}
    </Section>
  );
}
